import { Component, OnInit } from '@angular/core';
import { SurveyService } from '../rest_services/msSurveyServices/survey.service';
import { VisitService } from '../rest_services/visit.service';

@Component({
  selector: 'app-surveys-list',
  templateUrl: './surveys-list.component.html',
  styleUrls: ['./surveys-list.component.css']
})
export class SatisfactionRequestComponent implements OnInit {

  enqueteLoading: boolean =true;
  token:any;

  allsurveys :any[] = [
      { surveyNum: 1, createdAt: '2024-02-20', type: 'standard' },
      { surveyNum: 2, createdAt: '2024-02-19', type: 'perso1' },
      { surveyNum: 3, createdAt: '2024-02-18', type: 'perso2' },
      { surveyNum: 4, createdAt: '2024-02-21', type: 'perso3' },
      { surveyNum: 5, createdAt: '2024-02-22', type: 'perso4' },
  ];

    constructor(
      private msSurvey : SurveyService,
      private visitService:VisitService) { }

  ngOnInit(): void {
    if(localStorage.getItem("token")!=undefined) {
      this.token =localStorage.getItem("token");
    }else if(sessionStorage.getItem("token")!=undefined){
      this.token =sessionStorage.getItem("token");
    }
    
    this.getSurveyList();
    
  }
  survey_last_sent_to : any;
  getSurveyList(){
    this.msSurvey.getSurveyList();
    this.msSurvey.surveyListSubject.subscribe(
      ( data: any ) => {
        if(data.status== '200'){
          this.allsurveys = data.surveyList;
          this.allsurveys.forEach(survey => {
            this.visitService.getCustomerByVisit(survey.survey_last_sent_to, ['id', 'customer', 'logo']);
            this.visitService.detailSubject.subscribe(
              ( data: any ) => {
                if(data.code =="9ee6b80261f5935fcdc9848ac558b605"){
                  this.survey_last_sent_to = data.visit.visit_customer;
                }
              },
            )  
          });
          this.allsurveys.sort((a, b) => new Date(b.survey_last_sent_at).getTime() - new Date(a.survey_last_sent_at).getTime());
          setTimeout(() => {
            (<any>$("#alter_pagination")).DataTable( {
              "destroy":true,
              "pagingType": "full_numbers",
              "scrollX": '400px',
              "scrollCollapse": true,
              "aaSorting": [],
              "iDisplayLength": 25,
              // columnDefs: [ { type: 'date', 'targets': [2], "orderable": true } ],
              "language": {
                "sProcessing": "Traitement en cours ...",
                "sLengthMenu": "Afficher _MENU_ lignes",
                "sZeroRecords": "Aucun résultat trouvé",
                "sEmptyTable": "Aucune donnée disponible",
                "sInfo": "",
                "sInfoEmpty": "",
                searchPlaceholder: "Saisir un mot clé",
                "sInfoFiltered": "",
                "sInfoPostFix": "",
                "sSearch": "Rechercher:",
                "sUrl": "",
                "sInfoThousands": ",",
                "sLoadingRecords": "Chargement...",
                "oPaginate": {
                  "sFirst": "<i class='flaticon-left-arrow'></i>", "sLast": "<i class='flaticon-right-arrow'></i>", "sNext": "<i class='flaticon-arrow-right'></i>", "sPrevious": "<i class='flaticon-arrow-left-1'></i>"
                },
                "oAria": {
                  "sSortAscending": ": Trier par ordre croissant", "sSortDescending": ": Trier par ordre décroissant"
                }
              },
              drawCallback: function () {
                (<any>$('.sparkline')).sparkline([5,6,7,9,9,5,3,2,2,4,6,7], {
                      type: 'line',
                      width: '60',
                      height: '20',
                      lineColor: '#1a73e9',
                      fillColor: '#c2d5ff',
                      spotColor: 'transparent',
                      minSpotColor: 'transparent',
                      maxSpotColor: 'transparent',
                      highlightSpotColor: 'transparent',
                      highlightLineColor: 'transparent',
                  });
              }
            });
          }, 400);

          this.enqueteLoading=false;
        }
      },
    )    
  }
}
